/**
 * 契約詳細のバリデーションのエラーメッセージ。
 * サーバーと同じ文言にする（backend/core/src/services/credit_contracts/validation.rs）。
 * 月を差し込む文の引数は `YYYY-MM` の月で、`YYYY/MM` の形で示す。
 */

import { monthLabel } from './month';

export const messages = {
  startBlank: '開始月を入力してください。',
  startFormat: '開始月はYYYY/MMの形式で入力してください（例：2026/11）。',
  endFormat:
    '終了月はYYYY/MMの形式で入力してください（例：2027/03）。終了月がないときは空欄にしてください。',
  planRequired: '料金プランを選んでください。',
  numberBlank: '値を入力してください。',
  creditFormat:
    '半角の数字と小数点で入力してください（例：120、0.5）。桁区切りのカンマ、先頭の余分な0、符号、指数表記は使えません。',
  creditDigits: '整数部は10桁以内、小数点以下は8桁以内で入力してください。',
  aboveZero: '0より大きい値を入力してください。',
  yenFormat:
    '半角の数字で、小数点を付けずに入力してください（例：300000）。桁区切りのカンマ、先頭の余分な0、符号は使えません。',
  yenMax: '2147483647以下で入力してください。',
  atLeastOne: '1以上で入力してください。',
  endBeforeStart: (start: string) =>
    `終了月は、開始月（${monthLabel(start)}）以後の月にしてください。`,
  startNotAfterCurrent: (current: string) =>
    `開始月は、当月（${monthLabel(current)}）より後の月にしてください。`,
  activeEndBeforeCurrent: (current: string) =>
    `終了月は、空欄か、当月（${monthLabel(current)}）以後の月にしてください。`,
} as const;
